import r from "./authManager.js";
import o from "./colors.js";
import { device as e } from "./device.js";
import { e as t } from "../errors-YTprc4A2.mjs";
import { h as s } from "../helpers-CNa1KUVl.mjs";
import m, { addListener as a } from "./screenReader.js";
import { storage as p } from "./storage.js";
import { d as h } from "../constants-C9JADvZj.mjs";
import { d as b } from "../date-D-6ewr4B.mjs";
import { a as A } from "../api-CZJ4bXCT.mjs";
import { e as G } from "../events-CwIlKnwM.mjs";
import { s as F } from "../styled-qu50FBLM.mjs";
import { GlobalStyles as L, StyledGlobalCss as M } from "./globalStyles.js";
import { getInputTypeForAutoCompleteOff as T } from "./getInputType.js";
const g = {
  errors: t,
  AuthManager: r,
  helpers: s,
  storage: p,
  device: e,
  colors: o,
  screenReader: {
    screenReader: m,
    addListener: a
  }
};
export {
  r as AuthManager,
  L as GlobalStyles,
  M as StyledGlobalCss,
  F as Styling,
  A as api,
  o as colors,
  h as constants,
  b as date,
  g as default,
  e as device,
  t as errors,
  G as events,
  T as getInputTypeForAutoCompleteOff,
  s as helpers,
  p as storage
};
